import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExamsRoutingModule } from './exams-routing.module';
import { RegisterStudentOtpComponent } from './register-student-otp/register-student-otp.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { PaymentSuccessBulkPopupComponent } from './payment-success-bulk-popup/payment-success-bulk-popup.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';

@NgModule({
  declarations: [RegisterStudentOtpComponent, DeleteModalComponent, PaymentSuccessBulkPopupComponent],
  imports: [
    CommonModule,
    ExamsRoutingModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule
  ]
})
export class ExamsModule { }
